/*
 * Selectors for RestaurantDetails
 */

import { createSelector } from 'reselect';
const selectRestaurantDetailsDomain = (state) => state.get('restaurantDetails');
const selectRestaurantDetails = () => createSelector(
  selectRestaurantDetailsDomain,
  (RestaurantDetails) => RestaurantDetails.get('resturantData').toJS(),
);

const selectDealBooking = () => createSelector(
  selectRestaurantDetailsDomain,
  (RestaurantDetails) => RestaurantDetails.get('dealBooking').toJS(),
);
const select_isBoolean = (key) => createSelector(
  selectRestaurantDetailsDomain,
  (RestaurantDetails) => RestaurantDetails.get(key),
);
export { selectRestaurantDetails, selectDealBooking, select_isBoolean };



// WEBPACK FOOTER //
// client/containers/RestaurantDetails/selectors.js